<template>
  <v-container class="d-flex justify-center align-center mt-4">
    <base-material-card
      icon="mdi-repeat"
      color="primary"
      inline
      class="px-5 my-12 py-3"
    >
      <template v-slot:after-heading>
        <div class="title text-no-wrap font-weight-bold">
          <template v-if="recurringTask.type === 'recurrent'">
            {{ $t("newTask.titles.recurrent") }}
          </template>
          <template v-else>
            {{ $t("newTask.titles.onetime") }}
          </template>
          <br />
          <span
            v-if="equipmentProfile && equipmentProfile.equipTag"
            class="caption"
            >{{ $t("newTask.labels.tag") }}:
            {{ equipmentProfile.equipTag }}</span
          >
        </div>
      </template>
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            color="primary"
            fixed
            bottom
            left
            v-on="on"
            @click="$router.back()"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("newTask.buttons.back") }}</span>
      </v-tooltip>

      <v-form dark ref="form" v-model="valid" lazy-validation>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12" md="12" justify="center" align="center">
              <v-text-field
                filled
                :rules="requireRules"
                v-model="recurringTask.name"
                :label="$t('newTask.labels.name')"
              ></v-text-field> </v-col
            ><v-col cols="12" md="12" justify="center" align="center">
              <v-textarea
                filled
                :rules="requireRules"
                v-model="recurringTask.description"
                :label="$t('newTask.labels.description')"
              ></v-textarea>
            </v-col>
            <v-col cols="12" md="6" justify="center" align="center">
              <v-select
                :label="$t('newTask.labels.type')"
                v-model="recurringTask.subtype"
                :items="taskSubtypes"
                item-text="translation"
                return-object
                :rules="[v => !!v || $t('newConsumable.mandatoryField')]"
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="6" justify="center" align="center">
              <v-dialog
                ref="dialog"
                v-model="modal"
                :return-value.sync="recurringTask.initialDate"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="recurringTask.initialDate"
                    :label="$t('newTask.labels.due')"
                    prepend-icon="mdi-calendar"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="recurringTask.initialDate">
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">
                    {{ $t("newTask.buttons.cancel") }}
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.dialog.save(recurringTask.initialDate)"
                  >
                    {{ $t("newTask.buttons.ok") }}
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>
          <template v-if="recurringTask.type === 'recurrent'">
            <v-divider class="my-2"></v-divider>
            <div class="title primary--text ">
              {{ $t("newTask.headers.taskFrequency") }}
            </div>
            <div class="caption">
              {{ $t("newTask.messages.taskFrequency") }}
            </div>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  clearable
                  clear-icon="mdi-cancel"
                  :rules="timeRules"
                  v-model="valueChangeTime"
                  :label="$t('newTask.labels.lifetime')"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="selectedChangeTime"
                  :items="timeObj"
                  item-text="name"
                  return-object
                >
                </v-select>
              </v-col>
            </v-row>
          </template>
          <v-divider class="my-2"></v-divider>
          <div class="title  primary--text">
            {{ $t("newTask.headers.notificationFrequency") }}
          </div>
          <div class="caption">
            {{ $t("newTask.messages.notificationFrequency") }}
          </div>
          <v-row>
            <v-col cols="6" justify="center" align="center">
              <v-text-field
                clearable
                clear-icon="mdi-cancel"
                :rules="timeRules"
                v-model="valueAlertTime"
                :label="$t('newTask.labels.alertTime')"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="selectedAlertTime"
                :items="timeObj"
                item-text="name"
                return-object
              >
              </v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              justify="center"
              align="center"
              class="font-italic red--text"
            >
              {{ finalText }}
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-btn
            block
            x-large
            color="primary"
            class="elevation-8 font-weight-bold mr-4"
            :disabled="
              recurringTask.type === 'recurrent' ? !valid || checker : !valid
            "
            @click="validate"
            >{{ $t("newTask.buttons.submit") }}</v-btn
          >
          <v-dialog persistent max-width="350px" v-model="modalAfter">
            <v-card>
              <v-container>
                <v-row justify="center">
                  <v-col cols="12">
                    <v-btn
                      color="primary"
                      block
                      class="my-2 mx-0"
                      @click="handleGoToProfile"
                    >
                      {{ $t("newTask.buttons.gotoTaskProfile") }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      block
                      class="my-2 mx-0"
                      @click="handleCreateAnotherTask"
                    >
                      {{ $t("newTask.buttons.gotoCreateTask") }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      block
                      class="my-2 mx-0"
                      @click="handleGoBackTo"
                    >
                      {{ $t("newTask.buttons.gotoPlanner") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </v-container>
      </v-form>
    </base-material-card>
  </v-container>
</template>

<script>
import { db, timestamp } from "@/plugins/db";
import { mapState } from "vuex";

export default {
  data() {
    return {
      options: {
        process: pos => [
          [pos[0], pos[1], { backgroundColor: "#e7b416" }],
          [pos[1], pos[2], { backgroundColor: "#2dc937" }],
          [pos[2], pos[3], { backgroundColor: "#e7b416" }]
        ],
        railStyle: { backgroundColor: "#cc3232" },
        enableCross: true,
        tooltipStyle: { backgroundColor: "#C72A23" }
      },

      modal: false,
      modalAfter: false,
      snackbar: false,
      valid: false,
      timeObj: [
        { name: this.$t("newTask.date.year"), value: 31536000 },
        { name: this.$t("newTask.date.month"), value: 2592000 },
        { name: this.$t("newTask.date.week"), value: 604800 },
        { name: this.$t("newTask.date.day"), value: 86400 }
      ],
      taskSubtypes: [
        {
          name: "maintenance",
          translation: this.$t("newTask.labels.subtypes.maintenance")
        },
        {
          name: "repair",
          translation: this.$t("newTask.labels.subtypes.repair")
        },
        {
          name: "reliability",
          translation: this.$t("newTask.labels.subtypes.reliability")
        }
      ],
      recurringTask: {
        name: "",
        initialDate: new Date().toISOString().substring(0, 10),
        changeTime: 0,
        alertTime: 0,
        type: this.$route.params.type || "unique"
      },
      selectedChangeTime: { name: this.$t("newTask.date.day"), value: 86400 },
      selectedAlertTime: { name: this.$t("newTask.date.day"), value: 86400 },
      valueChangeTime: 0,
      valueAlertTime: 0,
      requireRules: [v => !!v || this.$t("newConsumable.mandatoryField")],
      timeRules: [v => v > 0 || this.$t("newConsumable.greaterThanZero")],
      responseUid: null
    };
  },
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("auth", ["user"]),
    changeTimeRealValue() {
      return this.valueChangeTime * this.selectedChangeTime.value;
    },
    alertTimeRealValue() {
      return this.valueAlertTime * this.selectedAlertTime.value;
    },
    checker() {
      if (this.recurringTask.type === "unique") return false;
      return this.alertTimeRealValue >= this.changeTimeRealValue;
    },
    finalText() {
      if (this.checker && this.recurringTask.type === "recurrent")
        return this.$t("newTask.messages.finaltext");
      return "";
    },
    nextDateInTimestamp() {
      if (!this.recurringTask || !this.recurringTask.initialDate) return null;
      return this.$moment(
        new Date(
          +new Date(this.recurringTask.initialDate) +
            this.changeTimeRealValue * 1000
        )
      ).format("YYYY-MM-DD");
    },
    nextDate() {
      if (!this.recurringTask || !this.recurringTask.initialDate) return null;

      return this.formatDateWithTranslate(
        this.recurringTask.initialDate,
        this.changeTimeRealValue
      );
    }
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch(
      "equipments/bindAnEquipment",
      this.$route.params.equipId
    );
    loading.close();
  },
  methods: {
    formatDateWithTranslate: function(lastChange, timeChange) {
      const jsDate = +new Date(lastChange) + timeChange * 1000;

      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      };

      const lang = this.user.language ? this.user.language : "en";
      return new Intl.DateTimeFormat(lang, options).format(jsDate);
    },
    async validate() {
      if (this.$refs.form.validate()) {
        const res = await this.$dialog.confirm({
          text: this.$t("dashboard.canYouConfirm"),
          title: this.$t("dashboard.checkFields")
        });
        if (res == true) {
          const loading = this.$vs.loading({
            background: "#730D0B",
            color: "rgb(255, 255, 255)",
            opacity: 1,
            type: "square"
          });

          let payload = {
            db: "calendar",
            data: {
              disabled: false,
              dateCreated: timestamp,
              createdBy: this.user.email,
              equipmentProfile: db
                .collection("equipments")
                .doc(this.equipmentProfile.id),
              name: this.recurringTask.name,
              description: this.recurringTask.description,
              details: this.recurringTask.description,
              start: this.recurringTask.initialDate,
              end: this.recurringTask.initialDate,
              lastChange: this.recurringTask.initialDate,
              changeTime: this.changeTimeRealValue,
              alertTime: this.alertTimeRealValue,
              type: this.recurringTask.type,
              subtype: this.recurringTask.subtype.name,
              disabledArray: [],
              baseLink: "/task-profile/",
              isDone: false
            }
          };

          try {
            const responseUid = await this.$store.dispatch(
              "addDocument",
              payload
            );
            this.responseUid = responseUid;

            this.$dialog.notify.success(
              "Your new recurring task has been created successfully",
              {
                position: "top-right",
                timeout: 5000
              }
            );
            this.showAfterModal();

            this.recurringTask = {
              name: "",
              initialDate: new Date().toISOString().substring(0, 10),
              changeTime: 0,
              alertTime: 0,
              type: this.$route.params.type
            };
            this.$refs.form.reset();
            this.selectedChangeTime = { name: "day", value: 86400 };
            this.selectedAlertTime = { name: "day", value: 86400 };

            loading.close();
          } catch (error) {
            this.$dialog.notify.error(error, {
              position: "top-right",
              timeout: 5000
            });
          }
          loading.close();
        }
      }
    },
    showAfterModal() {
      this.modalAfter = true;
    },
    handleGoToProfile() {
      this.$router.push({
        name: "TaskProfile",
        params: { id: this.responseUid }
      });
    },
    handleCreateAnotherTask() {
      this.responseUid = null;
      this.modalAfter = false;
    },
    handleGoBackTo() {
      this.$router.push({
        path: `/equipment/${this.equipmentProfile.id}/planner`
      });
    }
  }
};
</script>

<style></style>
